<template>
  <van-checkbox-group v-model="cart_goods_addons[strName]" :checked-color="checkColor" shape="square">
    <van-cell-group>
      <van-cell v-for="(item, key) in arrItems" :key="key" :title="item.title" :clickable="item.is_selected == 0" @click="checkBoxSelect(item,key)">
        <div class="attr-price">RM {{item.price}}</div>
        <van-checkbox :disabled="item.is_selected == 1" slot="right-icon" shape="square" :name="item.id"/>
      </van-cell>
    </van-cell-group>
  </van-checkbox-group>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { FASTORDER } from '@/constants'

export default {
  name: "cart",
  props: {
    arrItems: {
      type: Array
    },
    strName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      checkColor: FASTORDER == "FastOrder" ? '#ee2d24': '#6f3592',
      curAttr: [],
      aint: 0,
      old_cart_goods_addons: {}, //保存旧的规格选项值
      aitm: [] // 点击后保存的值放这里
    };
  },
  computed: {
    ...mapGetters(["cart_goods_addons"])
  },
  created () {
    this.old_cart_goods_addons["name"] = this.strName;
    this.old_cart_goods_addons["value"] = this.cart_goods_addons[this.strName];
    // console.log('old_cart_goods_addons=========', this.strName, this.old_cart_goods_addons.value);
    if (this.old_cart_goods_addons["value"].length > 0) {
      this.arrItems && this.arrItems.forEach(item => {
        const vurAttr = { [item.start]: item.title, "optionid": item.id, "price": item.price };
        if (this.old_cart_goods_addons["value"].includes(item.id)) {
          this.curAttr.push(vurAttr)
        }
      })
      // console.log('old_cart_goods_addons=========', this.strName, this.curAttr);
    }
    this.checkBoxSelected()
  },
  methods: {
    ...mapActions({
      setRadioAddons: "shoppping_cart/settingRadioGoodsAddons"
    }),
    checkBoxSelected(){
      if (this.curAttr.length > 0){
        for (let v in this.arrItems){
          for (let j;j<this.curAttr.length;j++){
            if (this.arrItems[v].is_selected == 1){
              if (this.curAttr[j].optionid == this.arrItems[v].id){
                continue;
              } else {
                console.log('curAttr array ', this.curAttr[j])
                this.chooseAttr(this.arrItems[v],v)
              }
            }
          }
        }
      } else {
        for (let v in this.arrItems){
          if (this.arrItems[v].is_selected == 1){
            this.chooseAttr(this.arrItems[v],v)
          }
        }
      }
    },
    checkBoxSelect(item,key){
      if (item.is_selected == 0){
        this.chooseAttr(item,key)
      }
    },
    isNullOrEmpty (param) {
      if (param == null || param === undefined || param === "") {
        return true;
      }
      return false;
    },
    checkboxOldAddons (item) {
      let addonsList = this.cart_goods_addons;
      let oldAddonsValue = this.old_cart_goods_addons && this.old_cart_goods_addons.value;
      if (oldAddonsValue.includes(item.id)) {
        //从[oldAddons]中删除已存在item值
        const addonsVal = oldAddonsValue.filter(im => im != item.id)
        addonsList[this.strName] = addonsVal;
      } else {
        addonsList[this.strName] = [...oldAddonsValue, item.id];
        this.aitm = [item.id];
      }
      return addonsList
    },
    checkboxAddons (item) {
      const addosList = this.cart_goods_addons;
      let addonsAint = []
      if (this.aint === 0 && addosList[this.strName].length > 0) {
        addonsAint = this.checkboxOldAddons(item)
      } else {
        let curAitm = this.aitm;
        console.log('curAitm', curAitm);
        if (curAitm.includes(item.id)) {
          curAitm.splice(
            curAitm.findIndex(imVal => imVal === item.id),
            1
          );
          this.aitm = curAitm;
        } else {
          this.aitm = [...this.aitm, item.id];
        }

        //todoVar[this.strName] = this.aitm;
      }
    },

    getCheckboxIDs (listOldIDs, item) {
      if (listOldIDs.includes(item.id)) {
        //取消勾选
        const idList = listOldIDs.filter(im => im != item.id)
        this.aitm = idList
        return idList
      } else {
        //需要勾选中
        const idList = [...listOldIDs, item.id]
        this.aitm.push(item.id)
        console.log('需要勾选中', listOldIDs, item.id, this.aitm);
        return idList
      }
    },
    chooseAttr (item, key) {
      console.log('item passed when click on condiment ', item)
      const addonsLength = this.cart_goods_addons[this.strName].length
      if (this.aint === 0) {
        if (addonsLength < 1) {
          this.aitm.push(item.id)
          this.cart_goods_addons[this.strName] = this.aitm
        } else {
          const listOldIDs = this.cart_goods_addons[this.strName]
          const listIDs = this.getCheckboxIDs(listOldIDs, item)
          this.cart_goods_addons[this.strName] = listIDs
        }
        this.aint++
      } else {
        let curAitm = this.aitm;
        if (curAitm.includes(item.id)) {
          curAitm.splice(curAitm.findIndex(imVal => imVal === item.id), 1);
          this.aitm = curAitm;
        } else {
          this.aitm = [...this.aitm, item.id];
        }
        this.cart_goods_addons[this.strName] = this.aitm
      }
      console.log('cart_goods_addons ',this.cart_goods_addons)
      const addonsList = this.cart_goods_addons
      this.setRadioAddons(addonsList);
      const arrVal = () => {
        let xxaa = []
        Object.values(addonsList).forEach(item => {
          console.log('item Object addonsList ',item)
          if (typeof item === 'object') {
            new Set(item).forEach(im => {
              if (im != "") {
                xxaa = [...xxaa, im]
              }
            })
          } else {
            if (item != "") {
              xxaa = [...xxaa, item]
            }
          }
        })
        return xxaa
      }
      console.log('更新规格后的数据', arrVal());
      console.log('**************', addonsList[this.strName], item.id);



      const vurAttr = { [item.start]: item.title, "optionid": item.id, "price": item.price };
      if (addonsList[this.strName].includes(item.id)) {
        if (this.curAttr.length < 1) {
          this.curAttr.push(vurAttr);
        } else {
          const filterCurAttr = this.curAttr && this.curAttr.filter(im => im.optionid != item.id)
          this.curAttr = filterCurAttr
          this.curAttr.push(vurAttr)
        }
      } else {
        const newCurAttrList = this.curAttr && this.curAttr.filter(ctem => ctem.optionid != item.id)
        this.curAttr = newCurAttrList

      }

      console.log("[curAttr]等于++++", this.curAttr);
      if (this.cart_goods_addons[this.strName] === "" || this.cart_goods_addons[this.strName] === []) {
        this.$emit("evtChooseAttr", this.curAttr, this.strName, false);
      } else {
        console.log('[22].........', this.curAttr);
        this.$emit("evtChooseAttr", this.curAttr, this.strName, true);
      }

    },
    chooseAttr2222 (item, key) {
      let arrAddons = []

      const todo = () => {
        let todoVar = this.cart_goods_addons;
        if (this.aint === 0 && todoVar[this.strName].length > 0) {
          const todoVar2 = this.checkboxOldAddons(item)
          /**
           * aint=0为第一次点击复选框,并且当前规格有的已经被选中，则需要判断，如下
           * 1， 如果当前点中的item.id和当前规格的数组 - 有同样的值，则表示是要取消勾选
           * 2， 如果当前点中的item.id和当前规格的数组 - 没有同样的值，则表示是要勾选
           * 判断后并返回最新的数据
           */
          todoVar = todoVar2
        } else {
          let curAitm = this.aitm;
          console.log('curAitm', curAitm);
          if (curAitm.includes(item.id)) {
            curAitm.splice(
              curAitm.findIndex(imVal => imVal === item.id),
              1
            );
            this.aitm = curAitm;
          } else {
            this.aitm = [...this.aitm, item.id];
          }

          //todoVar[this.strName] = this.aitm;
        }
        return todoVar;
      };
      const finalAddos = todo();
      console.log("finalAddos[" + this.strName + "]++++++++++", finalAddos);
      console.log("finalAddos[" + this.strName + "]++++++++++", finalAddos[this.strName]);

      this.aint++;
      this.setRadioAddons(finalAddos);

      const vurAttr = { [item.start]: item.title, "optionid": item.id, "price": item.id };
      if (finalAddos[this.strName].includes(item.id)) {
        if (this.curAttr.length < 1) {
          this.curAttr.push(vurAttr);
        } else {
          const filterCurAttr = this.curAttr && this.curAttr.filter(im => im.optionid != item.id)
          this.curAttr = filterCurAttr
          this.curAttr.push(vurAttr)
        }
      } else {
        const newCurAttrList = this.curAttr && this.curAttr.filter(ctem => ctem.optionid != item.id)
        this.curAttr = newCurAttrList
      }

      console.log("[curAttr]等于++++", this.curAttr);
      if (this.cart_goods_addons[this.strName] === "" || this.cart_goods_addons[this.strName] === []) {
        this.$emit("evtChooseAttr", this.curAttr, this.strName, false);
      } else {
        console.log('[22].........', this.curAttr);
        this.$emit("evtChooseAttr", this.curAttr, this.strName, true);
      }
    }
  }
};
</script>
<style lang="less" scoped>
</style>